// import { mapGetters } from 'vuex';
import Pagination from '@/components/pagination/index.vue';
import AssetsService from '../../service.js';
import Service from '@/service/index.js';
import LocationSelect from '@/components/location-select/index.vue';

export default {
  components: {
    Pagination,
    LocationSelect
  },
  props: ['identification'],
  data () {
    return {
      listShow: true,
      activeName: '0',
      pageType: '',
      total: 0,
      tableList: [],
      Assetslist: [],
      projectType: '1',
      projectTypeArr: [],
      projectSubTypeArr: [],
      assetsLargeTypearr: [],
      subTypeObj: {},
      TypeObj: {},
      asstesType: '',
      searchForm: {
        pageNum: 1,
        pageSize: 5,
        type: 0
      },
      areaCode: '',
      form: {
        assetsAddress: '',
        assetsName: '',
        address: '',
        village: '',
        type: '',
        identification: ''
      },
      rules: {
        assetsName: [
          { required: true, message: '请输入地块名称', trigger: 'blur' }
        ],
        village: [
          { required: true, message: '请选择完整的坐落位置', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'change' }
        ]
      },
      assetsStatusArr: [
        { code: 0, value: '可用' },
        { code: 1, value: '审核中' },
        { code: 2, value: '交易中' },
        { code: 3, value: '已流转' },
        { code: 4, value: '已到期' }
      ] // 资产状态
    };
  },

  created () {
    this.asstesType = this.$route.query.asstesType;
    this.editorid = this.$route.query.editorid;
    if (this.editorid) {
      AssetsService.batchgetUpdateBatchAllAssets(this.editorid).then(({ code, data }) => {
        if (code === '0') {
          this.tableList = data;
          // this.identification = data[0].identification;
        }
      });
      AssetsService.getUpdateBatchInfoAllAssets(this.editorid).then(({ code, data }) => {
        if (code === '0') {
          this.form.assetsName = data.assetsName;
          this.form.address = data.address;
        }
      });
    } else {
      // this.getList();
    }
    Service.getSelectList('ASSETS_LARGE_TYPE').then(({ code, data }) => {
      if (code === '0') {
        // this.assetsLargeTypearr1 = data;
        this.assetsLargeTypearr = data;
        this.assetsLargeTypearr.map(res => {
          res.list.map(item => {
            this.TypeObj[`${res.code}-${item.code}`] = item.value;
            // console.log(this.TypeObj);
            item.list.map(subItem => {
              this.subTypeObj[`${res.code}-${item.code}-${subItem.code}`] = subItem.value;
            });
          });
        });
        this.getList();
      }
    });
  },
  mounted () {
    this.getcityInfo();
  },
  methods: {
    // 获取注册时候位置信息
    getcityInfo () {
      AssetsService.getUserBaseInfo().then(res => {
        if (res && res.code === '0') {
          if (this.areaCode === res.data.county) {
            this.areaCode = res.data.village;
            this.address = res.data.addressDetail.split(' ')[1] + res.data.addressDetail.split(' ')[2] + res.data.addressDetail.split(' ')[3] + res.data.addressDetail.split(' ')[4];
          }
        }
      });
    },
    areaCodeChange (event) {
      const key = event && event.type;
      this.form[key] = event.areaCode;
      this.areaCode = event.areaCode;

      setTimeout(() => {
        const childRef = this.$refs['locationSelect'] && this.$refs['locationSelect'].$refs;
        if (childRef) {
          this.address = Object.keys(childRef).reduce((current, item) => {
            return current += childRef[item].selectedLabel;
          }, '');
        }
        const address = Object.keys(childRef).reduce((current, item) => {
          return current += childRef[item].selectedLabel;
        }, '');
        if (!new RegExp('[0-9]').test(address)) {
          this.address = address;
        }
        // console.log(this.address);
        this.form.assetsAddress = this.address;
        this.length = 50 - this.address.trim().length;
      }, 500);

    },
    handleClick () {
      this.searchForm.type = Number(this.activeName);
      this.pageNo = 1;
      this.getList();
    },
    getList () {
      // console.log(this.$route.query.identification);
      if (this.$route.query.identification) {
        AssetsService.pageAssetsInfo(this.$route.query.identification).then(res => {
          if (res.code === '0') {
            this.tableList = res.data;
          } else {
            errorMessage(res.reason);
          }
        }, (error) => {
          if (error && error.data && error.data.reason) {
            errorMessage(error.data.reason);
          }
        });
      } else {
        AssetsService.pageAssetsInfo(this.identification).then(res => {
          if (res.code === '0') {
            this.tableList = res.data;
          } else {
            errorMessage(res.reason);
          }
        }, (error) => {
          if (error && error.data && error.data.reason) {
            errorMessage(error.data.reason);
          }
        });
      }

    },
    // 详情
    goDetails (item) {
      if (this.editorid) {
        this.$router.push({ path: '/person-center/resources-assets/assdetail?id=' + item.id + '&editorid=' + this.editorid + '&asstesType=' + this.asstesType });

      } else {
        this.$router.push({ path: '/person-center/resources-assets/assdetail?id=' + item.id + '&identification=' + this.identification + '&asstesType=' + this.asstesType });

      }
    },
    // 申请流转
    goApply (item) {
      console.log(item);
      this.$router.push({ path: '/publish-project/project-info', query: { assetsCode: item.assetsCode } });
    },
    // 资源资产登记
    addAssets (e) {
      this.$router.push({ path: '/person-center/resources-assets/add?asstesType=' + e });
    },
    changeType () {
      this.listShow = false;
    },
    previousStep () {
      // this.$router.back();
      this.$router.push({ path: '/person-center/resources-assets/classification'});

    },
    submit () {
      this.form.type = this.asstesType;
      this.form.id = this.editorid;
      this.form.identification = this.identification;
      this.$refs['rules'].validate((valid) => {
        if (valid) {
          if (this.tableList.length === 0) {
            this.$errorMessage('请添加资产');
          } else {
            if (this.editorid) {
              AssetsService.updateBatchAllAssets(this.form).then(res => {
                if (res.code === '0') {
                  this.$successMessage('资产添加成功');
                  this.$router.push({ path: '/person-center/resources-assets/list' });
                }
              }).catch(error => {
                console.log(error, '===error');
              });
            } else {
              AssetsService.addBatchAllAssets(this.form).then(res => {
                if (res.code === '0') {
                  this.$successMessage('资产添加成功');
                  this.$router.push({ path: '/person-center/resources-assets/list' });
                }
              }).catch(error => {
                console.log(error, '===error');
              });
            }
          }
        }
      });
    },
    goDelete (id) {
      // console.log(e);
      this.$confirm('是否确定要删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        AssetsService.deleteAssetsInfo(id).then(res => {
          if (res && res.code === '0') {
            this.$successMessage('删除成功');
            this.getList();
          } else {
            errorMessage(res && res.reason);
          }
        }, (error) => {
          if (error && error.data && error.data.reason) {
            errorMessage(error.data.reason);
          }
        });
      });
    }
  }
};

